<template>
	<div>
		<template v-if="column">
			<span v-if="!value" style="font-size:12px;color:#F56C6C">{{valuetext}}</span>
			<el-link v-else type="success" style="font-size:12px" @click="auditorinfo">{{valuetext}}</el-link>
		</template>
		<template v-else>
			<el-select size="mini" :value="value" clearable transfer filterable placeholder="请选择" @change="change" :collapse-tags="true">
				<el-option label="未审核" value="0"></el-option>
				<el-option label="已审核" value="1"></el-option>
			</el-select>
		</template>
	</div>
</template>

<script>
	import inputBase from '@_system/components/base/input.js'
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [inputBase, selectBase],
		props: {
			table: {
				type: Object,
				default: () => {
					return null
				}
			},
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
			column: {
				type: Object,
				default: () => {
					return null
				}
			},
			moduleName: {
				type: String,
				default: () => {
					return ''
				}
			},
		},
		data() {
			return {

			}
		},
		created() {

		},
		mounted() {

		},
		watch: {

		},
		computed: {

			valuetext() {
				if (!this.value) {
					return '未审核'
				} else {
					return '已审核'
				}
			}
		},
		methods: {
			auditorinfo() {
				

			}
		},
		components: {

		}
	}
</script>
